module.exports = __webpack_public_path__ + "static/media/redur.194ca978.svg";